// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
import { site } from "@/content/site";

export default function AboutPage() {
  return (
    <>
      <section className="section">
        <div className="content">
          <div className="w-layout-grid grid-solutions-large stretch">
            <div className="solutions-large center">
              <div className="block-icon-solution">
                <img src="/assets/cdn/6564625fba90770b2c64ed5b_abilitics%20sybol%20white.svg" loading="eager" alt="" className="icon-solution" />
              </div>
              <h1 className="heading-solution-large h1-as-h4">About Abilitics</h1>
              <p className="paragraph-solution-large">
                Our mission is to use AI to help humans build stronger relationships. To do so, we form ventures with reputable partners, aiming to address the different challenges in the process of relationship building across Sales, HR and Communities.
              </p>
              <h4 className="heading-solution-large">Key Figures</h4>
              <div className="block-list">
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">100+ customers served in areas of HR, Sales and Communities</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">2 440 000 man-hours of software development done</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">6 ventures launched</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">{site.yearsOnMarket} years on the market</h6>
                </div>
              </div>
            </div>
            <div data-w-id="947af320-b420-aff7-6fde-b47c9d759471" className="lottie">
              <div className="lines-b1">
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
              </div>
              <div className="lines-b2">
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
              </div>
              <div className="block-lottie">
                <div data-w-id="947af320-b420-aff7-6fde-b47c9d759481" data-is-ix2-target="1" className="lottie-animation-1" data-animation-type="lottie" data-src="/assets/cdn/6560a307abb64a6b2f42860a_Animation%20B1.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="1.3" data-duration="0" data-loading="eager" />
                <div className="lottie-animation-2" data-w-id="947af320-b420-aff7-6fde-b47c9d759482" data-animation-type="lottie" data-src="/assets/cdn/6560a36351d6ae8449783981_Animation%20B2.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="15.033333333333333" data-duration="0" data-loading="eager" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="content">
          <div className="w-layout-grid grid-solutions-large block">
            <div className="solutions-large center transparent">
              <img src="/assets/cdn/65646dae6ea8de2869916cfb_Corporate-Culture.webp" loading="lazy" sizes="(max-width: 479px) 69vw, (max-width: 767px) 79vw, (max-width: 991px) 84vw, (max-width: 1279px) 86vw, 1100.800048828125px" srcSet="/assets/cdn/65646dae6ea8de2869916cfb_Corporate-Culture-p-500.webp 500w, /assets/cdn/65646dae6ea8de2869916cfb_Corporate-Culture-p-800.webp 800w, /assets/cdn/65646dae6ea8de2869916cfb_Corporate-Culture.webp 1000w" alt="Colleagues discussing ideas in a meeting" className="image-100-width" />
            </div>
            <div className="solutions-large transparent">
              <div className="block-icon-solution">
                <img src="/assets/cdn/6564691cdda0650d63eebadc_Corporate%20Culture-01.svg" loading="eager" alt="" className="icon-solution" />
              </div>
              <h4 className="heading-solution-large">Our culture</h4>
              <p className="paragraph-solution-large">We are:</p>
              <div className="block-list">
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">A Family</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">Striving for excellence and professionalism</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">Fighting side by side with our Partners and co-founders</h6>
                </div>
              </div>
              <p className="paragraph-solution-large">
                We are pioneers in building one of the few successful Venture Studio models in South-Eastern Europe. Our studio:
              </p>
              <div className="block-list">
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">Is human-centric</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">Respects the individual</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">Believes AI can be used to better humanity</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">Loves sharing knowledge with its partners</h6>
                </div>
                <div className="list">
                  <div className="block-icon-list about-us">
                    <img src="/assets/cdn/6564651f7aef60b1ee336b47_check%20cyan.svg" loading="eager" alt="" className="icon-list" />
                  </div>
                  <h6 className="heading-list blue">Aims at building trustworthy relationships</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="Team" className="section">
        <div className="content">
          <div className="block-heading center">
            <div className="subtitle">
              Get in Touch
              <br />
            </div>
            <h2 className="heading large">Leadership Team</h2>
          </div>
          <div className="lottie-wrapper">
            <div className="contact-lottie">
              <div className="contact-lottie-link">
                <div className="block-icon-contact-lottie">
                  <img src="/assets/cdn/655dfd1658ca065efffe0f1f_image.webp" loading="eager" sizes="(max-width: 479px) 27vw, (max-width: 767px) 13vw, (max-width: 1279px) 80px, (max-width: 1439px) 6vw, 80px" srcSet="/assets/cdn/655dfd1658ca065efffe0f1f_image-p-500.webp 500w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-800.webp 800w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-1080.webp 1080w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-1600.webp 1600w, /assets/cdn/655dfd1658ca065efffe0f1f_image.webp 2000w" alt="Rossen Zhivkov" className="icon-contact-lottie team" />
                </div>
                <div className="block-heading-contact-lottie members">
                  <div className="members-heading">
                    <h4 className="heading-contact-lottie memebers">Rossen Zhivkov</h4>
                    <div className="text-contact-lottie members">CEO</div>
                  </div>
                  <div className="members-links">
                    <div className="memebr-link">
                      <a href="mailto:rossen@abilitics.com" className="member-icon w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.387" height="20" viewBox="0 0 21.387 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <path className="a" d="M113.751,17.109l-9.859-7.114a1.408,1.408,0,0,0-1.646,0l-9.88,7.114h0V28.322a1.407,1.407,0,0,0,1.407,1.407h18.573a1.407,1.407,0,0,0,1.407-1.407V17.109Zm-9.881,7.118a1.408,1.408,0,0,1-1.646,0L92.366,17.11h21.385Z" transform="translate(-92.365 -9.729)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open email</div>
                      </a>
                      <a href="mailto:rossen@abilitics.com" className="text-link">rossen@abilitics.com</a>
                    </div>
                    <div className="memebr-link">
                      <a href="https://www.linkedin.com/in/rossenzhivkov/" target="_blank" className="w-inline-block">
                        <div className="member-icon w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.99" height="20" viewBox="0 0 19.99 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <rect className="a" width="4.127" height="13.333" transform="translate(0.396 6.667)" />
                            <path className="a" d="M2.44,0a2.461,2.461,0,0,0,0,4.921h0a2.45,2.45,0,0,0,2.44-2.46v0A2.449,2.449,0,0,0,2.44,0" transform="translate(0)" />
                            <path className="a" d="M15.139,6.26a4.646,4.646,0,0,0-4.018,2.2v-1.8H7.161V19.994h3.96V13c0-1.874.862-2.99,2.515-2.99,1.517,0,2.246,1.072,2.246,2.99v7H19.99V11.558c0-3.57-2.025-5.3-4.851-5.3" transform="translate(0)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open linkedin</div>
                      </a>
                      <a href="https://www.linkedin.com/in/rossenzhivkov/" target="_blank" className="text-link">rossenzhivkov</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-lottie-link a2">
                <div className="block-icon-contact-lottie">
                  <img src="/assets/cdn/655e0ced940937326c9db779_Jivko%20Petiov%20Circle.png" loading="eager" alt="Jivko Petiov" className="icon-contact-lottie team" />
                </div>
                <div className="block-heading-contact-lottie members">
                  <div className="members-heading">
                    <h4 className="heading-contact-lottie memebers">Jivko Petiov</h4>
                    <div className="text-contact-lottie members">CTO</div>
                  </div>
                  <div className="members-links">
                    <div className="memebr-link">
                      <a href="mailto:jivko@abilitics.com" className="member-icon w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.387" height="20" viewBox="0 0 21.387 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <path className="a" d="M113.751,17.109l-9.859-7.114a1.408,1.408,0,0,0-1.646,0l-9.88,7.114h0V28.322a1.407,1.407,0,0,0,1.407,1.407h18.573a1.407,1.407,0,0,0,1.407-1.407V17.109Zm-9.881,7.118a1.408,1.408,0,0,1-1.646,0L92.366,17.11h21.385Z" transform="translate(-92.365 -9.729)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open email</div>
                      </a>
                      <a href="mailto:jivko@abilitics.com" className="text-link">jivko@abilitics.com</a>
                    </div>
                    <div className="memebr-link">
                      <a href="https://www.linkedin.com/in/jivkopetiov/" target="_blank" className="w-inline-block">
                        <div className="member-icon w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.99" height="20" viewBox="0 0 19.99 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <rect className="a" width="4.127" height="13.333" transform="translate(0.396 6.667)" />
                            <path className="a" d="M2.44,0a2.461,2.461,0,0,0,0,4.921h0a2.45,2.45,0,0,0,2.44-2.46v0A2.449,2.449,0,0,0,2.44,0" transform="translate(0)" />
                            <path className="a" d="M15.139,6.26a4.646,4.646,0,0,0-4.018,2.2v-1.8H7.161V19.994h3.96V13c0-1.874.862-2.99,2.515-2.99,1.517,0,2.246,1.072,2.246,2.99v7H19.99V11.558c0-3.57-2.025-5.3-4.851-5.3" transform="translate(0)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open linkedin</div>
                      </a>
                      <a href="https://www.linkedin.com/in/jivkopetiov/" target="_blank" className="text-link">jivkopetiov</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-w-id="437572f4-03a2-32b2-6258-72876f2744fe" className="lottie">
              <div className="lines-c1">
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
              </div>
              <div className="lines-c2">
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
              </div>
              <div className="block-lottie">
                <div data-w-id="437572f4-03a2-32b2-6258-72876f27450d" data-is-ix2-target="1" className="lottie-animation-1" data-animation-type="lottie" data-src="/assets/cdn/6560a307da449238f4d1b55d_Animation%20C1.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="1.3" data-duration="0" data-loading="eager" />
                <div className="lottie-animation-2" data-w-id="437572f4-03a2-32b2-6258-72876f27450e" data-animation-type="lottie" data-src="/assets/cdn/6560a30751d6ae844977d430_Animation%20C2.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="12" data-duration="0" data-loading="eager" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="content">
          <div className="w-layout-grid grid-banner join">
            <div id="w-node-_13652ae4-1ac3-fbbd-4a02-50a33eb43038-e57488e7" className="block-banner">
              <div className="block-left">
                <div className="subtitle">
                  Are you ready?
                  <br />
                </div>
                <h3 className="heading banner">Join Abilitics</h3>
                <p className="paragraph white">
                  By joining Abilitics we will give you a chance to learn from the best, to become part of a family where people care for each other and will support your professional and personal development.
                </p>
                <div className="block-list join">
                  <ul role="list" className="list-join">
                    <li>You want to advance fast in your career</li>
                    <li>
                      You are willing to write the best of code, design the best of solutions and build trustworthy relationships
                    </li>
                    <li>You value the “We” more than the “I”</li>
                    <li>You like to continuously improve your skills</li>
                  </ul>
                </div>
                <p className="paragraph white">Then we would love to hear from you.</p>
                <a data-w-id="13652ae4-1ac3-fbbd-4a02-50a33eb4303e" href="https://abilitics.skillie.ai/jobs" target="_blank" className="button yellow w-button">See our open positions here</a>
              </div>
            </div>
            <div id="w-node-_13652ae4-1ac3-fbbd-4a02-50a33eb43040-e57488e7" data-w-id="13652ae4-1ac3-fbbd-4a02-50a33eb43040" className="lottie-banner join">
              <div className="lines-d1">
                <div style={{ width: "1px", height: "0%" }} className="line-banner-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-banner-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-banner-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-banner-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-banner-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-banner-w" />
              </div>
              <div className="lines-d2">
                <div style={{ width: "0%", height: "1px" }} className="line-banner-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-banner-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-banner-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-banner-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-banner-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-banner-h" />
              </div>
              <div className="block-lottie-banner">
                <div data-w-id="13652ae4-1ac3-fbbd-4a02-50a33eb43050" data-is-ix2-target="1" className="lottie-animation-1-banner" data-animation-type="lottie" data-src="/assets/cdn/655c5d4d25d668c29fb0f204_Lottie%20B1%20White.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-duration="0" data-loading="eager" />
                <div data-is-ix2-target="1" className="lottie-animation-2-banner" data-w-id="13652ae4-1ac3-fbbd-4a02-50a33eb43051" data-animation-type="lottie" data-src="/assets/cdn/655c5d4d25d668c29fb0f204_Lottie%20B1%20White.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-duration="0" data-loading="eager" />
                <div data-is-ix2-target="1" className="lottie-animation-2-blur-banner" data-w-id="13652ae4-1ac3-fbbd-4a02-50a33eb43052" data-animation-type="lottie" data-src="/assets/cdn/655c5d4d25d668c29fb0f214_Lottie%20D2%20Yellow.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="2" data-duration="0" data-loading="eager" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
